export var getMenus = function getMenus(type) {
  return [type === 'ps' && {
    label: '图片美化',
    bannerImg: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211207-171307-325c.png',
    color: '#33383E',
    title: '在线图片编辑',
    desc: '简单易用，分分钟出好图',
    href: 'https://www.gaoding.com/image',
    upload: 'https://www.gaoding.com/design/image?url=',
    isUpload: true,
    btns: [{
      icon: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211207-171557-0995.png',
      name: '批量调尺寸'
    }, {
      icon: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211207-171613-1b23.png',
      name: '批量加水印'
    }]
  }, {
    label: '智能抠图',
    bannerImg: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211207-145403-61cb.png',
    title: '一键删除图片背景',
    desc: 'AI智能抠图，如你所愿',
    href: 'https://koutu.gaoding.com/',
    upload: 'https://koutu.gaoding.com/clip?url=',
    isUpload: true,
    btns: [{
      icon: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211207-165856-a976.png',
      name: '批量抠商品'
    }, {
      icon: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211207-165915-9f94.png',
      name: '批量抠人物'
    }]
  }, {
    label: '在线拼图',
    href: 'https://www.gaoding.com/pintu',
    bannerImg: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-142200-5027.png',
    title: '在线拼图',
    desc: '自由调整，多布局轻松配'
  }, {
    label: '一键证件照',
    color: '#33383E',
    href: 'https://koutu.gaoding.com/passport',
    bannerImg: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211207-230043-4911.png',
    title: '轻松搞定证件照',
    desc: '小白也能做出完美证件照',
    isGloabl: true
  }].filter(function (val) {
    return !!val;
  });
};
export var PS_MENUS = getMenus('ps');
export var UUPOOP_MENUS = getMenus('uupoop');